import { IOption } from '@cmps/ng-select';
import { forkJoin, Observable, of, Subject } from 'rxjs';
import { mapTo, tap } from 'rxjs/operators';

import { catchErrorLogRet } from '../../../common/rest.operators';
import { epicDependencies } from '../../../store';
import {
    AreaItem,
    LobItem,
    PeerGroupItem,
    PopulationGroup,
    PopulationService,
    Queue,
    RegionItem,
    RoleItem,
    SiteItem,
    SuperGroupItem,
} from '../../core';
import { currentLookupState } from '../population-select.state';

export function load(): Observable<void> {
    const populationService =
        epicDependencies.injector.get<PopulationService>(PopulationService);

    const state = currentLookupState();

    if (state.loadingSubj?.isStopped === true) {
        return of(null);
    }

    if (state.loadingSubj != null) {
        return state.loadingSubj.asObservable();
    }

    state.loadingSubj = new Subject<void>();

    return forkJoin([
        populationService.listLobs().pipe(catchErrorLogRet([])),
        populationService.listRegions().pipe(catchErrorLogRet([])),
        populationService.listAreas().pipe(catchErrorLogRet([])),
        populationService.listSites().pipe(catchErrorLogRet([])),
        populationService.listSuperGroups().pipe(catchErrorLogRet([])),
        populationService.listPeerGroups().pipe(catchErrorLogRet([])),
        populationService.listRoles().pipe(catchErrorLogRet([])),
        populationService.listQueues().pipe(catchErrorLogRet([])),
        populationService.listPopulationGroups().pipe(catchErrorLogRet([])),
    ]).pipe(
        tap(
            ([
                lobs,
                regions,
                areas,
                sites,
                superGroups,
                peerGroups,
                roles,
                queues,
                populationGroups,
            ]: [
                LobItem[],
                RegionItem[],
                AreaItem[],
                SiteItem[],
                SuperGroupItem[],
                PeerGroupItem[],
                RoleItem[],
                Queue[],
                PopulationGroup[],
            ]) => {
                const mapper = (e: any): IOption => ({
                    value: e.id,
                    label: e.name,
                });
                state.lobs = lobs.map(mapper);
                state.regions = regions.map(mapper);
                state.areas = areas.map(mapper);
                state.sites = sites.map(mapper);
                state.superGroups = superGroups.map(mapper);
                state.peerGroups = peerGroups.map(mapper);
                state.roles = roles.map(mapper);
                state.queues = queues.map((e) => {
                    return {
                        value: e.queueId,
                        label: e.queueDefaultName,
                    };
                });
                state.populationGroups = populationGroups.map((e) => {
                    return {
                        value: e.populationGroupId,
                        label: e.populationGroupName,
                    };
                });

                state.loadingSubj.next();
                state.loadingSubj.complete();
            },
        ),
        mapTo(null),
    );
}
